import { Heart } from "lucide-react";

export const MenuItem = ({ product, onOrder }) => {
    return (
        <article
            className="bg-white rounded-3xl sss-shadow overflow-hidden flex flex-col"
            data-testid={`menu-item-${product.id}`}
        >
            <div className="aspect-[4/3] overflow-hidden bg-[var(--sss-blush)]">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                />
            </div>
            <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="font-serif-display text-xl md:text-2xl font-semibold leading-tight">
                    {product.name} <span>{product.emoji}</span>
                </h3>
                <ul className="mt-4 space-y-2 flex-1">
                    {product.sizes.map((s) => (
                        <li
                            key={s.label}
                            className="flex items-end text-sm"
                            data-testid={`menu-size-${product.id}-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            <span className="text-[var(--sss-text)]">{s.label}</span>
                            <span className="menu-leader" aria-hidden="true" />
                            <span className="font-serif-display font-bold">${s.price.toFixed(2)}</span>
                        </li>
                    ))}
                </ul>
                <button
                    type="button"
                    onClick={() => onOrder(product)}
                    className="btn-pink mt-5 text-sm justify-center"
                    data-testid={`menu-order-${product.id}`}
                >
                    Order Now <Heart size={14} fill="#fff" strokeWidth={0} />
                </button>
            </div>
        </article>
    );
};
